import React, { useEffect, useRef } from "react";
import { fieldValidation } from "../utils/field-validation";
import fieldPropTypes from "./field-prop-types";
import ValidationMessage from "../theme/default/validation-message";
import { idCreator } from "../utils/id-creator";

const FormTextView = ({ field, appData, components: { TextArea, Label } }) => {
  const wrapperRef = useRef(null);
  const {
    name,
    title,
    params,
    type,
    placeholder,
    data,
    accessibility = {}
  } = field;
  const {
    values,
    handleChange,
    resetFieldValidation,
    data: { screens },
    settings
  } = appData;
  const value = params.includes("TDFieldOptionCapitalizeCharacters")
    ? values[name].toUpperCase()
    : values[name];
  useEffect(() => {
    fieldValidation[type].update(field, appData, { fieldRef: wrapperRef });
  });
  const isInvalid =
    appData.fieldValidation[name] && !appData.fieldValidation[name].isValid;
  const { errorMessage } = appData.fieldValidation?.[name] ?? {};

  const valueLabelArr = screens.filter(
    item => item.name === "ExpertMedicalOpinionRecentDiagnosisConcerns"
  );

  const valueLabel = valueLabelArr[0]?.title || (
    <div style={{ visibility: "hidden" }}>
      {settings.translations.expert_medical_opinion}
    </div>
  );
  const isRequired =
    appData.showAsterisk && !field.params.includes("IsOptional") && field.title;

  const { label: textLabel } = accessibility;
  const { labelId, textAreaId } = idCreator(name);

  return (
    <div className='field-wrapper-web-sdk' ref={wrapperRef}>
      <Label
        text={title || valueLabel}
        isRequired={isRequired}
        name={name}
        id={labelId}
        inputId={textAreaId}
        appData={appData}
        params={params}
        srLabel={textLabel}
      >
        <TextArea
          name={name}
          value={value}
          inputMaxLength={data && data.max_length}
          onChange={e => {
            resetFieldValidation(name);
            handleChange({ [name]: e.target.value });
          }}
          readonly={params.includes("TDFieldOptionLocked")}
          invalid={isInvalid}
          placeholder={placeholder}
          labelId={labelId}
          id={textAreaId}
          appData={appData}
        />
      </Label>
      <ValidationMessage isInvalid={isInvalid}>
        {errorMessage}
      </ValidationMessage>
    </div>
  );
};

FormTextView.propTypes = fieldPropTypes;

export default FormTextView;
